import { OperatorFunction, filter } from 'rxjs';

export function filterNullish$<T>(isPure = true): OperatorFunction<T, T> {
  return isPure ? filter(v => v !== null && v !== undefined) : filter(v => !!v);
}
